var waitForFinalEvent = (function () {
  var timers = {};
  return function (callback, ms, uniqueId) {
    if (!uniqueId) {
      uniqueId = "Don't call this twice without a uniqueId";
    }
    if (timers[uniqueId]) {
      clearTimeout (timers[uniqueId]);
    }
    timers[uniqueId] = setTimeout(callback, ms);
  };
})();

(function($) {

//   $('#main-menu').easymenu();

  function setMainMenu(){

    // $.each($('.header .main-item'), function(){
    //   var $offset = $(this).offset().left - 1;
    //   $(this).find('ul').css('text-indent', $offset);
    // });

    $.each($('.header .main-item a'), function(){

      if($(this).html().toLowerCase() == 'sale'){
       $(this).addClass('color-red');
      }
    });

    $('.mobile-menu .main-item-link').on('click',function(){
      $('.mobile-menu .main-item-link').not(this).removeClass('active');
      $(this).toggleClass('active');
    })
  }

  setTimeout(setMainMenu, 500);

  $(window).resize(function () {
    waitForFinalEvent(function(){

//      setMainMenu();

      //...
    }, 300, "some unique string");
  });

  $('.footer-menu > .main-item-has-child > a').click(function(e){

    e.preventDefault();

    $(this).parent().find('ul').slideToggle(400, 'swing');
  });

  //   Open search panel
  $('.header-search-trigger').click(function(e){
    e.preventDefault();
    $(this).parent().find('.search-panel-wrapper').slideToggle(300, 'swing').find('form input[type="text"]').focus();
  });
  //   Close search panel
  $('.search-panel-close img').click(function(e){
    e.preventDefault();
    $(this).closest('.search-panel-wrapper').slideUp(300, 'swing').find('form input[type="text"]').focus();
  });

  //   Filter Panel  
  $('.filter-panel-wrapper-twin').height( $('.filter-panel-wrapper').height() + 50 );
  
  //   Open filter panel
  $('.header-filter-trigger').click(function(e){
    e.preventDefault();
    //     $(this).parent().find('.filter-panel-wrapper').slideToggle(300, 'swing');
    $('.filter-panel-wrapper').slideToggle(300, 'swing');
    $('.filter-panel-wrapper-twin').slideToggle(300, 'swing');
  });
  //   Close filter panel
  $('.filter-panel-close img').click(function(e){
    e.preventDefault();
//     $(this).closest('.filter-panel-wrapper').slideUp(300, 'swing');
    $('.filter-panel-wrapper').slideUp(300, 'swing');
    $('.filter-panel-wrapper-twin').slideToggle(300, 'swing');
  });
  //   Ends

  // Sliding products section
  const settings = {
    arrows: true,
    slidesToShow: 3,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 576,
        settings: "unslick"
      }
    ]

  };

  const sl =  $('.sliding-products-slider').slick(settings);

  $(window).resize(function () {
    waitForFinalEvent(function(){

      if( $(window).width() > 576 &&  !sl.hasClass('slick-initialized')) {
        $('.sliding-products-slider').slick(settings);
      }
      //...
    }, 300, "some unique string 123");
  });
  // Sliding products ends

  // Slide text in/out Dynamic Page Text Slider
  $( ".text-slider .section-text-title h2" ).click(function() {
    $( ".text-slider > .section-text-content" ).slideToggle(800);
  });


})(jQuery);

// Product filter accordion function.
(function($) {

  if(!$('body').hasClass('template-collection')){
    return;
  }

  function productFilter(){

    if($('.filter-panel-header .filter-panel-close').length > 0){

      // Removing previous event declaration
      $('.filter-panel-header').off('click');

      // Toggle panel
      $('.filter-panel-header').click(function(e){

        e.preventDefault();

        var $close = $($('.filter-panel-header .filter-panel-close')[0]);

        // Toggle only on mobile
        if($close.css('display') != 'none'){
          // Mobile
          $(this).find('i').toggleClass('rotate');
          $(this).closest('.filter-panel-column').find('.filter-panel-content').slideToggle();
        }
        else{
          // Desktop
        }
      });
    }
  }

  productFilter();

  $(window).resize(function () {
    waitForFinalEvent(function(){
      productFilter();
    }, 300, "productFilter");
  });
  
  $(document).on( 
    'keydown', function(event) { 
      if (event.key == "Escape") { 
        if($('.filter-panel-wrapper').is(':visible')){
          $('.filter-panel-close img').click();
        }
      } 
    }); 

})(jQuery);
// Product filter accordion function ends

// Youtube iFrame API
$(document).ready(function(){
  var tag = document.createElement('script');
  tag.src = "//youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  var players;
  // Player instances
  var YTplayers = [];

  window.onYouTubePlayerAPIReady = function(){

    players = document.querySelectorAll('.youtube-instance');

    for (var i = 0; i < players.length; i++) {

      var YTplayersTemp;

      YTplayersTemp = new YT.Player(players[i], {
        playerVars: {
          'autoplay': 0,
          'controls': 0,
          'mute': 1,
          'playsinline': 1,
          'loop': 0,
          'rel': 0
        },
        events: {
          'onReady': onPlayerReady,
          'onStateChange': onPlayerStateChange,
        },

        videoId: players[i].dataset.id
      });

      YTplayers.push(YTplayersTemp);
    }
  }

  function onPlayerReady(event) {
    event.target.mute();
    event.target.playVideo();
  }
  function onPlayerStateChange(event, state) {

    // Loop
    if (event.data == YT.PlayerState.ENDED) {
      event.target.seekTo(0);
      event.target.playVideo();
    }

    // Resume immediately after pause
    if(event.data == YT.PlayerState.PAUSED){
      event.target.playVideo();
    }
  }

  // On mouse enter
  $('.video-background, .video-foreground').mouseover(function(){

    var videoIndex = $(this).find('iframe').attr('data-index');
    var $player = YTplayers[videoIndex];

    if($player.getPlayerState() == YT.PlayerState.ENDED){
      $player.playVideo();
    }
  });


});
// Youtube iFrame API ends


// Ajax API

/**
 * jQuery.getUrlVars
 *
 * Copyright 2013, Matthew Cobbs
 * MIT Licensed
 */
/*global jQuery */
(function (window, $) {

    "use strict";

    var prevHref; // prev parsed href
    var prevVars; // prev parsed vars

    /**
     * parse the location object for search and hash parameters.
     * hash parameters take precedence over search
     *
     * @return {Object} values mapped to parameter keys
     */
    var parseLocation = function () {
        var location = window.location;
        var search = decodeURIComponent(location.search);
        var hash = decodeURIComponent(location.hash);
        var i, l, v; // loop vars
        var vars = {};

        search = search.replace("?", "").split("&");
        hash = hash.replace("#", "").split("&");

        for (i = 0, l = search.length; i < l; i++) {
            v = search[i].split("=");
            if (v[0]) {
                vars[v[0]] = v[1];
            }
        }

        for (i = 0, l = hash.length; i < l; i++) {
            v = hash[i].split("=");
            if (v[0]) {
                vars[v[0]] = v[1];
            }
        }

        prevHref = location.href;
        prevVars = vars;

        return vars;
    };

    // parse the initial location
    prevVars = parseLocation();

    /**
     * Get the URL parameters from the current href
     *
     * @return {Object} Values mapped to parameter keys
     */
    $.getUrlVars = function () {
        var href = window.location.href;
        var vars;

        if (href === prevHref) {
            vars = prevVars;
        } else {
            vars = parseLocation();
        }

        return vars;
    };

    /**
     * Get a single value from the getUrlVars object
     *
     * @param {String} key The object key
     * @return {String}
     */
    $.getUrlVar = function (key) {
        return $.getUrlVars()[key];
    };

}(this, jQuery));


// Filter begin
$(document).ready(function(){

  $('.filter-item').click(function(e){

    e.preventDefault();

    if($(this).hasClass('disabled')){
      return;
    }

    $(this).toggleClass('filter-active');

    var panel = $('.filter-panel');

    var active = $(this).hasClass('filter-active');

    var filterType = $(this).attr('data-filter-type');
    console.log("filterType: ", filterType)

    var filterValues = panel.find('.filter-active[data-filter-type="' + filterType + '"]');

    var values = [];

    $.each(filterValues, function(){
      values.push($(this).html());
    });

    if(values.length == 0){
      values = '';
    }

    if(filterType == 'color'){

      changeAnchorPart ({
        color: values
      });
    }

    if(filterType == 'cupsize'){

      changeAnchorPart ({
        cupsize: values
      });
    }

    if(filterType == 'intsize'){

      changeAnchorPart ({
        intsize: values
      });
    }

    if(filterType == 'fit'){

      changeAnchorPart ({
        fit: values
      });
    }

    if(filterType == 'style'){

      changeAnchorPart ({
        style: values
      });
    }

  });
});

/*
 * changeAnchorPart
 * Example code for changeAnchorPart.
 *
 * I plan to incorporate much of this into
 * the core uriAnchor plugin in the future.
*/

/*jslint         browser : true, continue : true,
  devel  : true, indent  : 2,    maxerr   : 50,
  newcap : true, nomen   : true, plusplus : true,
  regexp : true, sloppy  : true, vars     : false,
  white  : true
*/
/*global $, spa */

var stateMap  = { anchor_map : {} },

    copyAnchorMap,
    changeAnchorPart,
    onHashchange
;

// Begin utility method /copyAnchorMap/
// Returns copy of stored anchor map; minimizes overhead
copyAnchorMap = function () {
  return $.extend( true, {}, stateMap.anchor_map );
};
// End utility method /copyAnchorMap/

// Begin DOM method /changeAnchorPart/
// Purpose    : Changes part of the URI anchor component
// Arguments  :
//   * arg_map - The map describing what part of the URI anchor
//     we want changed.
// Returns    :
//   * true  - the Anchor portion of the URI was updated
//   * false - the Anchor portion of the URI could not be updated
// Actions    :
//   The current anchor rep stored in stateMap.anchor_map.
//   See uriAnchor for a discussion of encoding.
//   This method
//     * Creates a copy of this map using copyAnchorMap().
//     * Modifies the key-values using arg_map.
//     * Manages the distinction between independent
//       and dependent values in the encoding.
//     * Attempts to change the URI using uriAnchor.
//     * Returns true on success, and false on failure.
//
changeAnchorPart = function ( arg_map ) {
  var
    anchor_map_revise = copyAnchorMap(),
    bool_return       = true,
    key_name, key_name_dep;

  // Begin merge changes into anchor map
  KEYVAL:
  for ( key_name in arg_map ) {
    if ( arg_map.hasOwnProperty( key_name ) ) {

      // skip dependent keys during iteration
      if ( key_name.indexOf( '_' ) === 0 ) { continue KEYVAL; }

      // update independent key value
      anchor_map_revise[key_name] = arg_map[key_name];

      // update matching dependent key
      key_name_dep = '_' + key_name;
      if ( arg_map[key_name_dep] ) {
        anchor_map_revise[key_name_dep] = arg_map[key_name_dep];
      }
      else {
        delete anchor_map_revise[key_name_dep];
        delete anchor_map_revise['_s' + key_name_dep];
      }
    }
  }
  // End merge changes into anchor map

  // Begin attempt to update URI; revert if not successful
  try {
    $.uriAnchor.setAnchor( anchor_map_revise );
    
//     console.log($.uriAnchor.getAnchor( anchor_map_revise, null, false, 'https://www.opaak.de/collections/bestselling-styles-1' ));
    
    setCollectionLinks();
  }
  catch ( error ) {
    // replace URI with existing state
    $.uriAnchor.setAnchor( stateMap.anchor_map,null,true );
    bool_return = false;
  }
  // End attempt to update URI...

  return bool_return;
};
// End DOM method /changeAnchorPart/

// Begin Event handler /onHashchange/
// Purpose    : Handles the hashchange event
// Arguments  :
//   * event - jQuery event object.
// Settings   : none
// Returns    : false
// Actions    :
//   * Parses the URI anchor component
//   * Compares proposed application state with current
//   * Adjust the application only where proposed state
//     differs from existing and is allowed by anchor schema
//
var onHashChange = function ( /*event*/ ) {

  var anchor_prior_map, anchor_proposed_map;
  anchor_prior_map = copyAnchorMap();

  // attempt to parse anchor
  try {
    anchor_proposed_map = $.uriAnchor.makeAnchorMap();
  }
  catch ( error ) {
    $.uriAnchor.setAnchor( anchor_prior_map, null, true );
    return false;
  }
  stateMap.anchor_map = anchor_proposed_map;

  filterProducts();
};

// Building collection list links to keep Filter
function setCollectionLinks(){
  
  var $col = $('.filter-panel-list-collections li a');
  
  $.each( $col, function(){
    var $a = $(this);
    var $link = $a.attr('href');
    $a.addClass('hi');
    $a.attr('data-link', $link);
    var uri_array = document.location.href.split( '#',2 );
    var $newLink = $link + '#' + uri_array[1];
    $a.attr('href', $newLink);
  });
}

$(document).ready(function(){
 if(!$('body').hasClass('template-collection'))
   return;

  onHashChange();

  var anchorMap = copyAnchorMap();

  if(anchorMap.hasOwnProperty('style')){
    if(anchorMap.style.length > 0){
      // Style
      var styleQuery = getHashValue('style');
      var styleArray = [];

      if(styleQuery){
        styleArray = styleQuery.split(",");
      }

      var style;
      for(var i = 0; i < styleArray.length; i++){
        style = styleArray[i];
        $('.filter-item[data-value="' + style + '"]').addClass('filter-active');
      }
    }
  }

  if(anchorMap.hasOwnProperty('fit')){
    if(anchorMap.style.length > 0){
      // Style
      var styleQuery = getHashValue('fit');
      var styleArray = [];

      if(styleQuery){
        styleArray = styleQuery.split(",");
      }

      var style;
      for(var i = 0; i < styleArray.length; i++){
        style = styleArray[i];
        $('.filter-item[data-value="' + style + '"]').addClass('filter-active');
      }
    }
  }

  if(anchorMap.hasOwnProperty('color')){
    if(anchorMap.color.length > 0){
      // Color
      var colorQuery = getHashValue('color');
      var colorArray = [];

      if(colorQuery){
        colorArray = colorQuery.split(",");
      }

      var color;
      for(var i = 0; i < colorArray.length; i++){
        color = colorArray[i];
        $('.filter-item[data-value="' + color + '"]').addClass('filter-active');
      }
    }
  }

  if(anchorMap.hasOwnProperty('cupsize')){
    if(anchorMap.cupsize.length > 0){
      // Cupsize
      var cupsizeQuery = getHashValue('cupsize');
      var cupsizeArray = [];

      if(cupsizeQuery){
        cupsizeArray = cupsizeQuery.split(",");
      }

      var cupsize;
      for(var i = 0; i < cupsizeArray.length; i++){
        cupsize = cupsizeArray[i];
        $('.filter-item[data-value="' + cupsize + '"]').addClass('filter-active');
      }
    }
  }
  
  if(anchorMap.hasOwnProperty('intsize')){
    if(anchorMap.intsize.length > 0){
      // Cupsize
      var cupsizeQuery = getHashValue('intsize');
      var cupsizeArray = [];

      if(cupsizeQuery){
        cupsizeArray = cupsizeQuery.split(",");
      }

      var cupsize;
      for(var i = 0; i < cupsizeArray.length; i++){
        cupsize = cupsizeArray[i];
        $('.filter-item[data-value="' + cupsize + '"]').addClass('filter-active');
      }
    }
  }
  
//   if($('.filter-active, .filter-panel-active,  .filter-panel-active-collection').length > 0){
//    $('.header-filter-trigger').trigger('click'); 
//   }

});

// Get a single hash value
var getHashValue = function(hash){

  var anchor_prior_map, anchor_proposed_map;
  anchor_prior_map = copyAnchorMap();

  // attempt to parse anchor
  try {
    anchor_proposed_map = $.uriAnchor.makeAnchorMap();
  }
  catch ( error ) {
    $.uriAnchor.setAnchor( anchor_prior_map, null, true );
    return false;
  }
  stateMap.anchor_map = anchor_proposed_map;

  return stateMap.anchor_map[hash];
}

$(window).bind( 'hashchange', onHashChange );

// Fetch Products using Admin API
var filterProducts = function(){

  //   Filtering
  var products = $('.product-item'),
      i, j,
      positive = [],
      negative = [],
      positiveColor = [],
      negativeColor = [],
      positiveCupsize = [],
      negativeCupsize = [],
      positiveFit = [],
      negativeFit = [],
      positiveStyle = [],
      negativeStyle = [],
      positiveIntsize = [],
      negativeIntsize = [],
      isPositive = false,
      filterCount = 0;

  //   Color
  var infoColors, $colors, colorArray = [];
  var colorQuery = getHashValue('color');
  if(colorQuery){
    colorArray = colorQuery.split(",");
    filterCount++;
  }

  //   Cupsize
  var infoCupsizes, cupSizes, cupsizeArray = [];
  var cupSizeQuery = getHashValue('cupsize');
  if(cupSizeQuery){
    cupsizeArray = cupSizeQuery.split(",");
    filterCount++;
  }

  //   Style
  var infoStyles, styles, styleArray = [];
  var styleQuery = getHashValue('style');
  if(styleQuery){
    styleArray = styleQuery.split(",");
    filterCount++;
  }

  //   Fit
  var infoFits, fits, fitArray = [];
  var fitQuery = getHashValue('fit');
  if(fitQuery){
    fitArray = fitQuery.split(",");
    filterCount++;
  }
  
  //   Intsize
  var infoIntsizes, intSizes, intsizeArray = [];
  var intSizeQuery = getHashValue('intsize');
  if(intSizeQuery){
    intsizeArray = intSizeQuery.split(",");
    filterCount++;
  }

  if(!styleQuery && !colorQuery && !cupSizeQuery && !intSizeQuery && !fitQuery){

    $.each(products, function(){
      $(this).removeClass('hidden');
    });

   return;
  }

  $.each(products, function(){

    var product = $(this);
    isPositive = false;

    //     Color
    infoColors = [];

    $colors = product.find('.product-info-color span');
    for(var k = 0; k < $colors.length; k++){
      infoColors.push($($colors[k]).html());
    }

    if(colorArray.length > 0){
      if(findOne(infoColors, colorArray)){
        //         isPositive = true;
        //         positive.push($(this));
        positiveColor.push(product.attr('data-id'));
      }
    }

    //     Size
    infoCupsizes = [];

    cupSizes = $(this).find('.product-info-cupsize span');
    for(i = 0; i < cupSizes.length; i++){
      infoCupsizes.push($(cupSizes[i]).html());
    }

    if(cupsizeArray.length > 0){
      if(findOne(infoCupsizes, cupsizeArray)){
        //         isPositive = true;
        //         positive.push($(this));
        positiveCupsize.push($(this).attr('data-id'));
      }
    }

    //     Style
    infoStyles = [];

    styles = $(this).find('.product-info-style span');
    for(i = 0; i < styles.length; i++){
      infoStyles.push($(styles[i]).html());
    }

    if(styleArray.length > 0){
      if(findOne(infoStyles, styleArray)){
        //         isPositive = true;
        //         positive.push($(this));
        positiveStyle.push($(this).attr('data-id'));
      }
    }


    //     Fit
    infoFits = [];

    fits = $(this).find('.product-info-fit span');
    for(i = 0; i < fits.length; i++){
      infoFits.push($(fits[i]).html());
    }

    if(fitArray.length > 0){
      if(findOne(infoFits, fitArray)){
        //         isPositive = true;
        //         positive.push($(this));
        positiveFit.push($(this).attr('data-id'));
      }
    }
    
    //   Int  Size
    infoIntsizes = [];

    intSizes = $(this).find('.product-info-intsize span');
    for(i = 0; i < intSizes.length; i++){
      infoIntsizes.push($(intSizes[i]).html());
    }

    if(intsizeArray.length > 0){
      if(findOne(infoIntsizes, intsizeArray)){
        //         isPositive = true;
        //         positive.push($(this));
        positiveIntsize.push($(this).attr('data-id'));
      }
    }

    var productID = $(this).attr('data-id');
    var positives = [];

    if(positiveColor.length > 0){
     positives.push(positiveColor);
    }
    if(positiveCupsize.length > 0){
     positives.push(positiveCupsize);
    }
    if(positiveFit.length > 0){
     positives.push(positiveFit);
    }
    if(positiveStyle.length > 0){
     positives.push(positiveStyle);
    }
    if(positiveIntsize.length > 0){
     positives.push(positiveIntsize);
    }

    if(positives.length > 0){

      var found = 0;

      for(var i = 0; i < positives.length; i++){

        if(positives[i].includes(productID)){
          found++;
        }
      }

      if(found == filterCount){
        isPositive = true;
      }
    }


    if(!isPositive){
      negative.push($(this));
    }
    else{
      positive.push($(this));
    }

  });

  $.each(negative, function(){
    $(this).addClass('hidden');
  });

  $.each(positive, function(){
    $(this).removeClass('hidden');
  });
  
  var anchor_prior_map = copyAnchorMap();
}

// if and array contains another array
var findOne = function (haystack, arr) {
  return arr.some(function (v) {
    return haystack.indexOf(v) >= 0;
  });
};

// Function call
function findCommonElements2(arr1, arr2) {

  // Create an empty object
  let obj = {};

  // Loop through the first array
  for (let i = 0; i < arr1.length; i++) {

    // Check if element from first array
    // already exist in object or not
    if(!obj[arr1[i]]) {

      // If it doesn't exist assign the
      // properties equals to the
      // elements in the array
      const element = arr1[i];
      obj[element] = true;
    }
  }

  // Loop through the second array
  for (let j = 0; j < arr2.length ; j++) {

    // Check elements from second array exist
    // in the created object or not
    if(obj[arr2[j]]) {
      return true;
    }
  }
  return false;
}
// Filter product ends


// Product - Limiting product form scroll
function limitScroll(){
  
  if(!$('body').hasClass('template-product'))
    return;

  var followTo = ($('.product-image-slider').height() - $('.product-select').height()) / 2;
  
  $('.product-view__right').css('top', followTo).css('position', 'absolute').css('opacity','1');
  
}

$(document).ready(function(){
  
//   limitScroll();

  $(window).resize(function () {
    waitForFinalEvent(function(){
      limitScroll();
    }, 300, "limitScroll1");
  });
  
});

$(window).load(function(){
  limitScroll();
});
// Product - Suggestions ends


$(document).ready(function(){
  
  $('.open-language-popup-cart-link').magnificPopup({
    type:'inline',
    mainClass: 'mfp-fade',
    callbacks: {
        open: function(){
          $('.mfp-wrap').css("overflow-y", "scroll")
        },
      },
  });
  
});

// Product images
$(document).ready(function(){
  
  var elem = document.querySelector('.product-image-slider');
  var flkty = new Flickity( elem, {
    // options
    adaptiveHeight: false,
    wrapAround: true,
    autoPlay: false,
    cellCelector: '.slider-cell',
    pageDots: false,
    cellAlign: 'center',
    contain: true,
    resize: true,
    imagesLoaded: true,
    rightToLeft: false

  });
  
});

// Product Recommendation
$(window).load(function(){
  
  if(!$('body').hasClass('template-product'))
    return;
  
  if($('.product-recommendations').attr('data-has-metafield') == 'true'){
   return;
  }
  
  var loadProductRecommendationsIntoSection = function() {
    
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector(".product-recommendations");
    if (productRecommendationsSection === null) { return; }
    // Read product id from data attribute
    var productId = productRecommendationsSection.dataset.productId;
    // Read limit from data attribute
    var limit = productRecommendationsSection.dataset.limit;
    // Build request URL
    var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      var elem = document.querySelector('.recommendations-slider');
      //   for an individual element
      var flkty = new Flickity( elem, {
        // options
        adaptiveHeight: true,
        wrapAround: true,
        imagesLoaded: true,
        groupCells: true,
        autoPlay: false,
        cellCelector: '.recommendations-slider-cell',
        pageDots: false,
//         cellAlign: 'left',
//         contain: true,
//         resize: true
        rightToLeft: true

      });


      }
    };
    request.send();
  };
  // If your section has theme settings, the theme editor
  // reloads the section as you edit those settings. When that happens, the
  // recommendations need to be fetched again.
  // See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
  document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === "product-recommendations") {
      loadProductRecommendationsIntoSection();
    }
  });
  // Fetching the recommendations on page load

  setTimeout(function(){
    loadProductRecommendationsIntoSection();
  }, 800);
});

// Sliding Products - Flickity
$(document).ready(function(){
  
  // Manual recommended products
  if($('.product-recommendations').attr('data-has-metafield') != 'true'){
   return;
  }
  
  var rightToLeft = true;
  var cellAlign = 'right';
  
  if($('.recommendations-slider-cell').length <= 3){
    rightToLeft = false;
    cellAlign = 'left';
  }
  
  var elem = document.querySelector('.recommendations-slider');
  //   for an individual element
  var flkty = new Flickity( elem, {
    // options
    adaptiveHeight: true,
    wrapAround: true,
    imagesLoaded: true,
    autoPlay: false,
    cellCelector: '.recommendations-slider-cell',
    pageDots: false,
    cellAlign: cellAlign,
    contain: true,
    groupCells: true,
    resize: true,
    rightToLeft: rightToLeft

  });
});


// Sorting product grid item sizes
$(document).ready(function(){

  $.each($('.product-item-overlay'), function(){
	
    var sizes = $(this).find('span'),
        size;
    
    $.each(sizes, function(){
      size = $(this).html();
      if(size.length > 3)
        $(this).attr('data-position',size.substring(3, 4) + ' ' + size.substring(0, 2));
    });
    
    function sort_li(a, b){
      return ($(b).data('position')) < ($(a).data('position')) ? 1 : -1;    
    }
    
    $(this).html($(this).find("span").sort(sort_li));

  });
});


// Adding default option to product dropdowns
$(document).ready(function(){

  if(!$('body').hasClass('template-product'))
    return;

  var variant = $.getUrlVar('variant');
  var isSelected = "";

  // Adding default Please Select option to dropdowns
  if(typeof(variant) == 'undefined'){
    isSelected = "selected='selected'";

    $.each($('#product-select-option-0'), function(){
      var lbl = $(this).parent().find('label').html();
      $(this).prepend("<option value='' disabled='disabled' " + isSelected + ">" + lbl + "</option>");
    });
    
    $('#add-to-cart').addClass('disabled-no-option').html('Please Choose');
  }
  
  // Make dropdown borders red when there is an empty dropdown
  $('#add-to-cart.disabled-no-option').click(function(e){
    
    if($(this).hasClass('disabled-no-option')){
      $.each($('.single-option-selector'), function(){
        $(this).css('border','solid 1px #ff0000').css('outline','solid 1px #ff0000');
      });
    }
    else{
      $.each($('.single-option-selector'), function(){
        $(this).css('border','solid 1px #000').css('outline','none');
      });
    }
  });
  
  // If all dropdown are valid (has value), enable the button
  $('.single-option-selector').change(function(){
    
    var allValid = true;
    
    $.each($('.single-option-selector'), function(){

      if($(this).val() == null || $(this).val() == '' || typeof($(this).val()) == 'undefined'){
        allValid = false;
      }
    });
    
    if(allValid){
      $('#add-to-cart').removeClass('disabled-no-option');
      $('.single-option-selector').css('border','1px solid #000').css('outline','none');
    }
    
  });

});





// Color-Switcher: The color-variant dropdown redirects to the product page of that variant
$('.color_switcher select').on('change', function() {

  let url = this.value;

  if(url !== 'current_color') {
    window.location.href = url;
  }

});


